<div
  class="dialog-container"
  resizableDialog
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
>
  <div class="card max-95vh">
    <div class="card-header" cdkDragHandle>
      <div class="row">
        <div class="col-12 col-md-6 margin-auto">
          <h5>Component properties</h5>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-center">
          <mat-form-field class="no-subscript" id="typeBox">
            <mat-label>Component Type</mat-label>
            <input
              [disabled]="disabled"
              aria-label="type"
              matInput
              [(ngModel)]="component"
              [matAutocomplete]="autoType"
              (keyup)="filterControls($event)"
            />
            <mat-autocomplete
              [disabled]="disabled"
              class="autocomplete"
              #autoType="matAutocomplete"
              (optionSelected)="selectedType($event)"
              [displayWith]="displayType"
            >
              <mat-option
                *ngFor="let component of filteredComponents"
                [value]="component"
                matTooltip="{{ component.name }}"
              >
                {{ component.name }}
              </mat-option>
            </mat-autocomplete>
            <button
              (click)="$event.stopPropagation()"
              *ngIf="component"
              class="help-button"
              mat-icon-button
              color="primary"
              [matMenuTriggerFor]="componentHelp"
            >
              <mat-icon>help</mat-icon>
            </button>
            <mat-menu
              #componentHelp="matMenu"
              [overlapTrigger]="false"
              xPosition="before"
              class="menu"
            >
              <cl-editor-component-help
                [component]="component!"
                [disabled]="!isSA()"
              ></cl-editor-component-help>
            </mat-menu>
          </mat-form-field>
        </div>
        <div class="col-2 pt-2 text-right">
          <button
            class="btn btn-red ml-2"
            (click)="cancel()"
            [matTooltip]="'Cancel changes'"
          >
            <mat-icon>cancel</mat-icon>
          </button>
          <button
            *ngIf="!disabled"
            class="btn btn-green ml-2"
            (click)="accept()"
            [disabled]="checkAcceptDisabled() && !wfTableConfigID"
          >
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-9 pr-1 editor-body">
          <div class="row">
            <div class="col-12">
              <div class="pb-2">
                <mat-form-field
                  class="no-subscript mt-2"
                  *ngIf="
                    !component?.numericHeader &&
                    type != 13 &&
                    type != 7 &&
                    type != 22 &&
                    type != componentType.CheckboxSignature &&
                    type != componentType.ButtonSignature &&
                    type != componentType.ButtonSignatureDuplicate &&
                    type != componentType.Comments &&
                    type != componentType.CloseButton
                  "
                >
                  <mat-label>Label</mat-label>
                  <input
                    [disabled]="disabled"
                    aria-label="name"
                    matInput
                    type="text"
                    [(ngModel)]="name"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="
                  (component?.textFields ?? 0) >= 1 ||
                  type == componentType.CheckboxSignature ||
                  type == componentType.ButtonSignature ||
                  type == componentType.ButtonSignatureDuplicate ||
                  type == componentType.Comments ||
                  type == componentType.CloseButton
                "
              >
                <div class="row">
                  <div class="col-6">
                    <h6>Text field(s)</h6>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <span
                      id="placeholderMessage"
                      class="placeholderMessage small"
                      [innerHTML]="clipboardMessage"
                    ></span>
                    <button
                      mat-stroked-button
                      color="warn"
                      (click)="placeholders()"
                    >
                      {{ "{ }" }} <span class="text">Placeholders</span>
                    </button>
                  </div>
                </div>

                <div
                  class="pb-1"
                  *ngIf="
                    (component?.textFields ?? 0) >= 1 ||
                    type == componentType.CheckboxSignature ||
                    type == componentType.ButtonSignature ||
                    type == componentType.ButtonSignatureDuplicate ||
                    type == componentType.Comments ||
                    type == componentType.CloseButton
                  "
                >
                  <comments-box
                    [disabled]="disabled"
                    (textChanged)="textChanged($event, 1)"
                    [textValue]="t1"
                    [formType]="formType"
                    [serialNo]="serialNo"
                    [title]="'Text 1'"
                    [editor]="true"
                    [noSubscript]="true"
                  ></comments-box>
                </div>
                <div class="pb-1" *ngIf="(component?.textFields ?? 0) >= 2">
                  <comments-box
                    [disabled]="disabled"
                    (textChanged)="textChanged($event, 2)"
                    [textValue]="t2"
                    [formType]="formType"
                    [serialNo]="serialNo"
                    [title]="'Text 2'"
                    [editor]="true"
                    [noSubscript]="true"
                  ></comments-box>
                </div>

                <div class="pb-1" *ngIf="(component?.textFields ?? 0) >= 3">
                  <comments-box
                    [disabled]="disabled"
                    (textChanged)="textChanged($event, 3)"
                    [textValue]="t3"
                    [formType]="formType"
                    [serialNo]="serialNo"
                    [title]="'Text 3'"
                    [editor]="true"
                    [noSubscript]="true"
                  ></comments-box>
                </div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="row">
            <div class="col-7" *ngIf="component?.needActions">
              <div class="row mt-2">
                <div class="col-4 action">
                  <mat-checkbox
                    [disabled]="disabled"
                    color="primary"
                    [(ngModel)]="approveAction"
                    [labelPosition]="'before'"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="actionChanged()"
                  >
                    <mat-label>Approve</mat-label>
                  </mat-checkbox>
                </div>
                <div class="col-8">
                  <cl-editor-status
                    [disabled]="disabled"
                    *ngIf="approveAction && !wfTableConfigID"
                    [action]="wfAction.Approve"
                    [configuration]="s.configuration"
                    [color]="color"
                    [statusLabel]="'Next Status'"
                    [checklistTemplate]="checklistTemplate"
                    (selected)="actionStatusSelected($event, wfAction.Approve)"
                  ></cl-editor-status>
                  <cl-editor-next-step
                    [disabled]="disabled"
                    *ngIf="approveAction && wfTableConfigID"
                    [wfTableConfigID]="wfTableConfigID"
                    [wfStepConfigID]="s.approveNextStepConfigID"
                    (selected)="
                      actionNextStepSelected($event, wfAction.Approve)
                    "
                  >
                  </cl-editor-next-step>
                </div>
              </div>
              <div class="row">
                <div class="col-4 action">
                  <mat-checkbox
                    [disabled]="disabled"
                    color="accent"
                    [(ngModel)]="unapproveAction"
                    [ngModelOptions]="{ standalone: true }"
                    [labelPosition]="'before'"
                    (change)="actionChanged()"
                  >
                    <mat-label>Unapprove</mat-label>
                  </mat-checkbox>
                </div>
                <div class="col-8">
                  <cl-editor-status
                    [disabled]="disabled"
                    *ngIf="unapproveAction && !wfTableConfigID"
                    [action]="wfAction.Unapprove"
                    [configuration]="s.configuration"
                    [color]="color"
                    [statusLabel]="'Next Status'"
                    [checklistTemplate]="checklistTemplate"
                    (selected)="
                      actionStatusSelected($event, wfAction.Unapprove)
                    "
                  ></cl-editor-status>
                  <cl-editor-next-step
                    [disabled]="disabled"
                    *ngIf="unapproveAction && wfTableConfigID"
                    [wfTableConfigID]="wfTableConfigID"
                    [wfStepConfigID]="s.unapproveNextStepConfigID"
                    (selected)="
                      actionNextStepSelected($event, wfAction.Unapprove)
                    "
                  >
                  </cl-editor-next-step>
                </div>
              </div>
              <div class="row">
                <div class="col-4 action">
                  <mat-checkbox
                    [disabled]="disabled"
                    color="warn"
                    [(ngModel)]="disapproveAction"
                    [labelPosition]="'before'"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="actionChanged()"
                  >
                    <mat-label>Disapprove</mat-label>
                  </mat-checkbox>
                </div>
                <div class="col-8">
                  <cl-editor-status
                    [disabled]="disabled"
                    *ngIf="disapproveAction && !wfTableConfigID"
                    [action]="wfAction.Disapprove"
                    [configuration]="s.configuration"
                    [color]="color"
                    [statusLabel]="'Next Status'"
                    [checklistTemplate]="checklistTemplate"
                    (selected)="
                      actionStatusSelected($event, wfAction.Disapprove)
                    "
                  ></cl-editor-status>
                  <cl-editor-next-step
                    [disabled]="disabled"
                    *ngIf="disapproveAction && wfTableConfigID"
                    [wfTableConfigID]="wfTableConfigID"
                    [wfStepConfigID]="s.disapproveNextStepConfigID"
                    (selected)="
                      actionNextStepSelected($event, wfAction.Disapprove)
                    "
                  >
                  </cl-editor-next-step>
                </div>
              </div>
              <div class="row" *ngIf="isGlobalWorkflow">
                <div class="col-4 action">
                  <mat-checkbox
                    [disabled]="disabled"
                    color="warn"
                    [(ngModel)]="amendmentAction"
                    [labelPosition]="'before'"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="actionChanged()"
                  >
                    <mat-label>Amendment Request</mat-label>
                  </mat-checkbox>
                </div>
                <div class="col-8">
                  <cl-editor-status
                    [disabled]="disabled"
                    *ngIf="amendmentAction && !wfTableConfigID"
                    [action]="wfAction.Amendment"
                    [configuration]="s.configuration"
                    [color]="color"
                    [statusLabel]="'Next Status'"
                    [checklistTemplate]="checklistTemplate"
                    (selected)="
                      actionStatusSelected($event, wfAction.Amendment)
                    "
                  ></cl-editor-status>
                  <cl-editor-next-step
                    [disabled]="disabled"
                    *ngIf="amendmentAction && wfTableConfigID"
                    [wfTableConfigID]="wfTableConfigID"
                    [wfStepConfigID]="s.amendmentNextStepConfigID"
                    (selected)="
                      actionNextStepSelected($event, wfAction.Amendment)
                    "
                  >
                  </cl-editor-next-step>
                </div>
                <div class="col-4 action">
                  <mat-checkbox
                    [disabled]="disabled"
                    color="warn"
                    [(ngModel)]="cancelAction"
                    [labelPosition]="'before'"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="actionChanged()"
                  >
                    <mat-label>Cancel Form/Checklist</mat-label>
                  </mat-checkbox>
                </div>
                <div class="col-8">
                  <cl-editor-status
                    [disabled]="disabled"
                    *ngIf="cancelAction && !wfTableConfigID"
                    [action]="wfAction.Cancel"
                    [configuration]="s.configuration"
                    [color]="color"
                    [statusLabel]="'Next Status'"
                    [checklistTemplate]="checklistTemplate"
                    (selected)="actionStatusSelected($event, wfAction.Cancel)"
                  ></cl-editor-status>
                  <cl-editor-next-step
                    [disabled]="disabled"
                    *ngIf="cancelAction && wfTableConfigID"
                    [wfTableConfigID]="wfTableConfigID"
                    [wfStepConfigID]="s.cancelNextStepConfigID"
                    (selected)="actionNextStepSelected($event, wfAction.Cancel)"
                  >
                  </cl-editor-next-step>
                </div>
              </div>
            </div>

            <!-- end Actions -->

            <div class="col-5 pt-2">
              <mat-slide-toggle
                *ngIf="isGlobalWorkflow"
                class="mb-2"
                [color]="'primary'"
                [(ngModel)]="s.requesterSignature"
                [disabled]="disabled"
              >
                Is Requester Signature
              </mat-slide-toggle>

              <role-selection
                *ngIf="
                  !s.requesterSignature &&
                  component?.needRoles &&
                  !component?.hasMultipleRoles
                "
                [noSubscript]="true"
                [roles]="roles"
                [disabled]="disabled"
                (deleted)="removeRole($event)"
                (selected)="selectedRole($event)"
              ></role-selection>
            </div>

            <div
              class="col-6 pt-2"
              *ngIf="type == componentType.PlaceholderCondition"
            >
              <cl-editor-placeholder-select
                [configuration]="s.configuration"
                [text]="t1"
                (selected)="placeHolderSelected($event)"
              >
              </cl-editor-placeholder-select>
            </div>

            <div class="col-6 pt-2" *ngIf="type == componentType.StatusChange">
              <cl-editor-status-change
                [disabled]="disabled"
                [configuration]="s.configuration"
                [color]="color"
                [checklistTemplate]="checklistTemplate"
                (changed)="statusSelected($event)"
              ></cl-editor-status-change>
            </div>

            <div
              class="col-12 pt-2"
              *ngIf="type == componentType.MultipleStatusChange"
            >
              <cl-editor-multiple-status-change
                [disabled]="disabled"
                [configuration]="s.configuration"
                [checklistTemplate]="checklistTemplate"
                (changed)="statusSelected($event)"
              ></cl-editor-multiple-status-change>
            </div>

            <div
              class="col-6 pt-2"
              *ngIf="type == componentType.RadMonitorDueDate"
            >
              <cl-editor-rad-locations
                [disabled]="disabled"
                [configuration]="s.configuration"
                (changed)="configurationChanged($event)"
              >
              </cl-editor-rad-locations>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 pt-2 editor-body">
          <div class="row">
            <div class="col-12 pb-2" *ngIf="component?.hasConditions">
              <div class="d-flex">
                <mat-form-field
                  id="conditionsBox"
                  class="no-subscript mb-1 no-arrow-select"
                >
                  <mat-label>Conditions</mat-label>

                  <textarea
                    class="pr-4"
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="10"
                    [(ngModel)]="condition"
                    [disabled]="disabled"
                    [ngModelOptions]="{ standalone: true }"
                  ></textarea>
                  <button
                    class="help-button"
                    mat-icon-button
                    [mat-menu-trigger-for]="conditionsMenu"
                    color="primary"
                  >
                    <mat-icon>help</mat-icon>
                  </button>
                  <mat-menu
                    #conditionsMenu="matMenu"
                    class="no-padding-menu conditions-menu"
                    ><cl-editor-conditions-help
                      [(condition)]="condition"
                      [conditions]="conditions"
                      [formType]="formType"
                      [checklistConditions]="checklistConditions"
                      [checklistTasks]="checklistTasks"
                      [checklistTemplate]="checklistTemplate"
                    ></cl-editor-conditions-help
                  ></mat-menu>
                </mat-form-field>
              </div>

              <cl-editor-hide-disable-toggle
                [disabled]="disabled"
                *ngIf="condition"
                [configuration]="s.configuration"
                (changed)="configurationChanged($event)"
              ></cl-editor-hide-disable-toggle>
            </div>
            <div class="col-12" *ngIf="component?.hasTag">
              <div class="d-flex">
                <mat-form-field id="tagBox" class="no-subscript">
                  <mat-label>Tag</mat-label>
                  <input
                    [disabled]="disabled"
                    aria-label="code"
                    matInput
                    type="text"
                    [(ngModel)]="code"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    class="help-button"
                    mat-icon-button
                    color="primary"
                    [matMenuTriggerFor]="taginfo"
                  >
                    <mat-icon>help</mat-icon>
                  </button>
                  <mat-menu
                    #taginfo="matMenu"
                    class="no-padding-menu conditions-menu"
                    ><cl-editor-tag-info
                      [tag]="code"
                      [multi]="multi"
                      [component]="component"
                    ></cl-editor-tag-info
                  ></mat-menu>
                </mat-form-field>
              </div>
            </div>
            <div class="col-12" *ngIf="component?.hasSigConditions">
              <div class="d-flex">
                <mat-form-field id="sigConditionsBox" class="no-subscript mb-1">
                  <mat-label>Signature Condition</mat-label>
                  <mat-select
                    [(ngModel)]="sigCondition"
                    [disabled]="disabled"
                    [ngModelOptions]="{ standalone: true }"
                    (selectionChange)="formDirty = true"
                  >
                    <mat-option
                      *ngFor="let tag of availableTags"
                      [value]="tag"
                      [disabled]="isOwnTag(tag)"
                    >
                      {{ tag }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="Clear Signature Condition"
                  *ngIf="sigCondition && !disabled"
                  (click)="clearSigCondition()"
                >
                  <mat-icon>clear</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="primary"
                  (click)="infoPopup(sigCondition, code)"
                >
                  <mat-icon>help</mat-icon>
                </button>
              </div>
            </div>
            <div class="col-12 pt-2" *ngIf="component?.hasRadioButtons">
              <cl-editor-radio-options
                [disabled]="disabled"
                [options]="tmpOptions"
                [configuration]="s.configuration"
                (changed)="optionsChange($event)"
                (error)="error = $event"
                *ngIf="type != componentType.PlaceholderCondition"
              ></cl-editor-radio-options>
              <cl-editor-placeholder-options
                [disabled]="disabled"
                [options]="tmpOptions"
                [configuration]="s.configuration"
                (changed)="optionsChange($event)"
                *ngIf="type == componentType.PlaceholderCondition"
              >
              </cl-editor-placeholder-options>
            </div>

            <div
              class="col-12 pt-2"
              *ngIf="
                component?.hasMultipleCheckboxes && !component?.hasMultipleRoles
              "
            >
              <cl-editor-checkbox-options
                [disabled]="disabled"
                [options]="tmpOptions"
                [configuration]="s.configuration"
                (changed)="optionsChange($event)"
                (checkbox)="checkboxChanged($event)"
                (error)="error = $event"
              ></cl-editor-checkbox-options>
            </div>
            <div class="col-12 pt-2" *ngIf="component?.hasMultipleTextboxes">
              <cl-editor-textbox-options
                [disabled]="disabled"
                [options]="tmpOptions"
                [configuration]="s.configuration"
                (changed)="optionsChange($event)"
              ></cl-editor-textbox-options>
            </div>

            <div
              class="col-12 pt-2"
              *ngIf="
                type == componentType.ScheduleAndCheckbox ||
                type == componentType.ScheduleAbsi
              "
            >
              <cl-editor-schedule
                [disabled]="disabled"
                [configuration]="s.configuration"
                [scheduleTypeId]="s.scheduleTypeId"
                [scheduleResourceId]="s.scheduleResourceId"
                (scheduleChanged)="scheduleChanged($event)"
                [showLocation]="showScheduleLocationSelector"
              >
              </cl-editor-schedule>
            </div>
            <div
              class="col-12 pt-2"
              *ngIf="
                type == componentType.CheckboxRadioLocation ||
                type == componentType.Restrictions
              "
            >
              <cl-editor-location
                [disabled]="disabled"
                [resourceTypes]="
                  type == componentType.CheckboxRadioLocation
                    ? [resourceTypes.Branchline]
                    : [
                        resourceTypes.Accelerator,
                        resourceTypes.Shutter,
                        resourceTypes.Beamline,
                      ]
                "
                [configuration]="s.configuration"
                (changed)="locationChanged($event)"
              >
              </cl-editor-location>

              <cl-editor-restriction-toggle
                *ngIf="type == componentType.Restrictions"
                [configuration]="s.configuration"
                (configurationChange)="
                  configuration = $event; s.configuration = $event
                "
              >
              </cl-editor-restriction-toggle>
            </div>

            <div class="col-12 pt-2" *ngIf="component?.colorize">
              <cl-editor-colors
                [disabled]="disabled"
                [configuration]="s.configuration"
                (colorChanged)="colorChanged($event)"
              >
              </cl-editor-colors>
            </div>
            <!-- <div class="col-12 pt-2" *ngIf="type == componentType.BRATOI">
              <cl-editor-bratoi
                [disabled]="disabled"
                [configuration]="s.configuration"
                (changed)="BRATOIChanged($event)"
                (sendBRCRole)="setRoleByCode($event)"
              >
              </cl-editor-bratoi>
            </div> -->
            <div
              class="col-12 pt-2"
              *ngIf="type == componentType.ShieldingsComponent"
            >
              <cl-editor-sublocations
                [configuration]="s.configuration"
                (configurationChanged)="configurationChanged($event)"
              >
              </cl-editor-sublocations>
            </div>

            <div
              class="col-12 pt-2"
              *ngIf="type == componentType.OperationalApproval"
            >
              <cl-editor-checklist-type-selector
                [configuration]="s.configuration"
                [disabled]="disabled"
                (configurationChanged)="configurationChanged($event)"
              >
              </cl-editor-checklist-type-selector>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="type == componentType.RADSurveyImageTable">
        <div class="col-12 pt-2">
          <mat-accordion [MatAcc]>
            <mat-expansion-panel
              [expanded]="!noOptions"
              (opened)="noOptions = false"
              (closed)="noOptions = true"
            >
              <mat-expansion-panel-header>
                Table Options
              </mat-expansion-panel-header>
              <cl-editor-table-headers
                [disabled]="disabled"
                [configuration]="s.configuration"
                (changed)="headersChange($event)"
              >
              </cl-editor-table-headers>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      <div class="row" *ngIf="component?.hasMultipleRoles">
        <div class="col-12 pt-2">
          <cl-editor-checkbox-roles
            [disabled]="disabled"
            [options]="tmpOptions"
            [configuration]="s.configuration"
            (changed)="optionsChange($event)"
          ></cl-editor-checkbox-roles>
        </div>
      </div>
    </div>
    <div
      class="card-footer px-3 py-2 editor-footer"
      id="scrollableContainer-editor"
      [ngClass]="{ 'max-h-80': noOptions }"
    >
      <div class="row">
        <div class="col-12 pl-2">
          <master-control
            [s]="s"
            [type]="type"
            [visible]="true"
            [builder]="true"
            [editor]="true"
            [enabled]="true"
            [disabled]="disabled"
            [color]="color"
            [header]="component?.numericHeader ? '#' : name"
            [label]="name"
            [text]="clean(t1)"
            [question]="clean(t1)"
            [radioQuestion]="clean(t2)"
            [options]="options"
            [radioOptions]="options"
            [controlID]="s.value2"
            [checkbox_checked]="s.approved"
            [approved]="s.approved"
            [approvedBy]="s.approvedBy"
            [approvedOn]="s.approvedOn"
            [roleIds]=""
            [roleCodes]="s.roleCodes"
            [scheduleResourceId]="scheduleResourceId"
            [scheduleTypeId]="scheduleTypeId"
            [textBefore]="clean(t1)"
            [textAfter]="clean(t2)"
            [textAfter2]="clean(t3)"
            [textValue]="s.textValue"
            [checkboxVisible]="true"
            [disableEdit]="true"
            [dateValue1]="s.dateValue1"
            [dateValue2]="s.dateValue2"
            [dateValue3]="s.dateValue3"
            [locationName]="locationName"
            [taskId]="s.id"
            [configuration]="configuration"
            [editMode]="s.editMode"
            [enableColumns]="true"
            [currentChecklistTemplate]="checklistTemplate"
            (changed)="change($event)"
            (scheduleChanged)="scheduleChanged($event)"
            (save)="change($event)"
            style="width: 100%"
          >
          </master-control>
        </div>
      </div>
    </div>
  </div>
</div>
